import { render } from "./App.vue?vue&type=template&id=0f96cf50&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0f96cf50&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=0f96cf50&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f96cf50"]])

export default __exports__